import React, { useMemo } from 'react';
import RelatedBlock from './RelatedBlock';
import { ComponentProps } from 'lib/component-props';
import { useI18n } from 'next-localization';
import { useArticle } from 'hooks/useArticle';
import EEPlaceholder from 'components/Sections/EEPlaceholder';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

type RelatedCapabilitiesProps = ComponentProps & {
  sidebar?: boolean;
  className?: string;
};

const RelatedCapabilities: React.FC<RelatedCapabilitiesProps> = ({
  rendering,
  sidebar = true,
  className,
}) => {
  const {
    sitecoreContext: { pageEditing },
  } = useSitecoreContext();
  const { config, data } = useArticle();
  const { t } = useI18n();
  const items = useMemo(
    () =>
      config?.capabilityCards?.filter((capabilityCard) =>
        data?.articleData.articleCapabilities?.targetItems
          .map((c) => c.id)
          .includes(capabilityCard.id.replace('-', '').replace('{', '').replace('}', ''))
      ) ?? [],
    [config?.capabilityCards, data?.articleData.articleCapabilities?.targetItems]
  );

  const passThroughProps = {
    rendering,
    sidebar,
    title: t('relatedCapabilitiesTitle'),
    items,
    className,
  };

  if (pageEditing) return <EEPlaceholder>RelatedCapabilities Section</EEPlaceholder>;

  if (!config.showRelatedCapabilities || items.length === 0) return null;

  return <RelatedBlock {...passThroughProps} />;
};

export default RelatedCapabilities;
